import {gsap} from './gsap';

const $ = jQuery.noConflict();

'use strict';
/**
 * @description Fades/slides headings, content and images in as they scroll into view.
 * @description Any element with `.js-reveal` is auto-detected.
 * #description Element class : js-reveal
 * @example <h2 class="js-reveal" data-reveal="fade-up">Title</h2>
 * @example <div class="js-reveal" data-reveal-stagger="0.15"><p>...</p><img/></div>
 * @example Options (data attributes on `.js-reveal`):
 * @example data-reveal="fade-up|fade-down|fade-left|fade-right|fade|zoom-in" (default: fade-up)
 * @example data-reveal-duration="1.2" data-reveal-delay="150" data-reveal-stagger="0.15" data-reveal-once="false"
 */
const EFFECTS = {
	'fade-up': {from: {y: 40, opacity: 0}, to: {y: 0, opacity: 1}},
	'fade-down': {from: {y: -40, opacity: 0}, to: {y: 0, opacity: 1}},
	'fade-left': {from: {x: 40, opacity: 0}, to: {x: 0, opacity: 1}},
	'fade-right': {from: {x: -40, opacity: 0}, to: {x: 0, opacity: 1}},
	'fade': {from: {opacity: 0}, to: {opacity: 1}},
	'zoom-in': {from: {scale: 0.92, opacity: 0}, to: {scale: 1, opacity: 1}},
};

const ScrollReveal = {

	/** @description Initialize */
	init: function() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		this.cacheDOM();
		this.setup();
	},

	cacheDOM: function() {
		this.$items = $('.js-reveal');
	},

	setup: function() {
		this.$items.each((index, item) => this.setupItem($(item)));
	},

	setupItem: function($item) {
		const effect = EFFECTS[$item.data('reveal')] || EFFECTS['fade-up'];
		const stagger = parseFloat($item.data('reveal-stagger')) || 0;
		const duration = parseFloat($item.data('reveal-duration')) || 0.9;
		const delay = (parseFloat($item.data('reveal-delay')) || 0) / 1000;
		const once = $item.data('reveal-once') !== false;
		const targets = stagger ? $item.children().toArray() : $item.get(0);

		gsap.set(targets, effect.from);

		gsap.to(targets, {
			...effect.to,
			duration: duration,
			delay: delay,
			stagger: stagger,
			ease: 'power1.out',
			scrollTrigger: {
				trigger: $item.get(0),
				start: 'top 80%',
				toggleActions: once ? 'play none none none' : 'play reverse play reverse',
			},
		});
	},

};

export default ScrollReveal;
